"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../..");
var ConfigProvider_1 = require("../../../providers/ConfigProvider");
var either_1 = require("../../../utils/either");
var Input_1 = __importDefault(require("../inputs/Input"));
var IcoInputField = function (_a) {
    var name = _a.name, size = _a.size, readOnly = _a.readOnly, toolTip = _a.toolTip, type = _a.type, icoValidation = _a.icoValidation, druhOsoby = _a.druhOsoby, setErrorMessage = _a.setErrorMessage, placeholder = _a.placeholder;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var _c = react_1.useState(), loading = _c[0], setLoading = _c[1];
    var _d = react_1.useState(), check = _d[0], setCheck = _d[1];
    var apiUrl = ConfigProvider_1.useConfig().apiUrl;
    var getJSON = __1.useGetJSON(apiUrl + "/CheckIcoExists");
    var handleChange = function (e) {
        if (setErrorMessage)
            setErrorMessage(undefined);
        var val = e.target.value.replace(/[^0-9]/g, '');
        var max = 100000000;
        var maxLength = max.toString().length - 1;
        var newVal = val < max ? val : parseInt(val.toString().substring(0, maxLength), 10);
        helpers.setValue(newVal);
    };
    var checkIco = function (ico) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(icoValidation && !readOnly)) return [3 /*break*/, 2];
                    setLoading(true);
                    if (setErrorMessage)
                        setErrorMessage(undefined);
                    return [4 /*yield*/, getJSON({ ico: ico || field.value, idDruhOsoby: druhOsoby })];
                case 1:
                    response = _a.sent();
                    if (either_1.isRight(response)) {
                        if (response.value) {
                            setCheck(false);
                            if (setErrorMessage)
                                setErrorMessage('Zadané IČO je již evidováno u jiné osoby.');
                        }
                        else {
                            setCheck(true);
                        }
                    }
                    setLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleKeyUp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var length;
        var _a;
        return __generator(this, function (_b) {
            setCheck(undefined);
            length = (_a = String(field.value)) === null || _a === void 0 ? void 0 : _a.length;
            if (length === 8) {
                checkIco();
            }
            return [2 /*return*/];
        });
    }); };
    var handleOnBlur = function () { return __awaiter(void 0, void 0, void 0, function () {
        var length, numberOfZeros, zeros, i, ico;
        var _a;
        return __generator(this, function (_b) {
            length = (_a = String(field.value)) === null || _a === void 0 ? void 0 : _a.length;
            if (length < 8 && length > 2 && String(field.value) !== 'null') {
                numberOfZeros = 8 - length;
                zeros = '';
                // eslint-disable-next-line no-plusplus
                for (i = 0; i < numberOfZeros; i++) {
                    zeros = "0" + zeros;
                }
                ico = zeros + String(field.value);
                helpers.setValue(ico);
                checkIco(ico);
            }
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement(Input_1.default, __assign({}, field, { value: field.value || '', name: name, hasError: !!meta.error, size: size, readOnly: readOnly, toolTip: toolTip, type: type, onKeyUp: handleKeyUp, loading: loading, check: field.value ? check : undefined, onBlur: handleOnBlur, onChange: handleChange, onWheel: function (e) { return e.target.blur(); }, placeholder: placeholder })));
};
IcoInputField.defaultProps = {
    size: undefined,
    readOnly: false,
    toolTip: undefined,
    type: 'text',
    icoValidation: false,
    druhOsoby: undefined,
    setErrorMessage: undefined,
    placeholder: undefined,
};
exports.default = IcoInputField;
